<template>
  <div :class="['custom-input', `custom-input-${size}`]">
    <aside class="common-input-box"
      :class="verify ? 'common-input-box-red' : (GotFocus || (value && value.length)) ? 'common-input-box-active' : ''">
      <div class="label-text"
        :class="(GotFocus || (value && value.length)) ? 'label-active' : ''"
        @click="inputGotFocus">
        <span class="required" v-show="required">*</span>
        {{ label }}
      </div>
      <input :type="inputType"
        :disabled="disabled"
        ref="inputControl"
        :class="['inputControl',disabled ? 'disabled-input' :'']"
        :placeholder="placeholder"
        :value="value"
        :maxlength="maxlength"
        :autocomplete="autocomplete"
        @blur="inputControlOnblur"
        @focus="inputControlOnfocus"
        v-on:input="$emit('change', $event.target.value)" />
      <i @click="rest" v-show="clearable && focus && value" class="el-icon-error input-icon cursor-pointer" />
      <i @click="passIsShow = !passIsShow" v-show="type ==='password'" :class="['iconfont', 'cursor-pointer', 'input-icon', passIsShow ? 'icon-zhengyan':'icon-biyan1']"></i>
    </aside>
    <div class="verify" :class="verifyText === 'password' ? 'verify-password' : ''">{{verify}}</div>
  </div>
</template>

<script>
export default {
  name: 'inputBox',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    type: {type: String, default: 'text'},
    clearable: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    label: String,
    placeholder: String,
    value: [String, Number],
    maxlength: String,
    required: {type: Boolean, default: false},
    autocomplete: String,
    size: {type: String, default: ''},
    verify: {type: String, default: ''},
    verifyText: {type: String, default: ''}
  },
  data () {
    return {
      GotFocus: false,
      focus: false,
      passIsShow: false
    }
  },
  watch: {
    value (val) { if (val) { this.GotFocus = true } }
  },
  computed: {
    inputType () {
      if (this.type === 'password') {
        if (this.passIsShow) {
          return 'text'
        } else {
          return 'password'
        }
      } else {
        return this.type
      }
    }
  },
  methods: {
    inputGotFocus () {
      this.GotFocus = true
      this.$refs.inputControl && this.$refs.inputControl.focus()
    },
    inputControlOnblur () {
      setTimeout(() => {
        this.focus = false
      }, 300)
      this.$refs.inputControl && this.$refs.inputControl.blur()
      if (!this.value || !this.value.toString()) {
        this.GotFocus = false
      }
    },
    inputControlOnfocus () {
      this.focus = true
      this.GotFocus = true
    },
    rest () {
      this.$emit('update:value', '')
      this.$emit('change', '')
      this.$refs.inputControl && this.$refs.inputControl.focus()
      setTimeout(() => {
        this.focus = true
      }, 500)
    }
  }
}
</script>

<style lang="scss">
.custom-input {
  width: 100%;
  height: 50px;
  position: relative;
  .verify{
    position: absolute;
    bottom: -16px;
    left: 0;
    color: #BB0628;
    font-size: 12px;
  }
  .verify-password{
    bottom: -28px;
  }
  & + .custom-input {
    margin-top: 24px;
  }

  .common-input-box {
    height: 48px;
    background: #ffffff;
    border: 1px solid #cecbd4;
    margin-top: 1px;
    margin-bottom: 1px;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    .label-text {
      font-size: 16px;
      font-weight: bold;
      color: #1d1d1f;
      line-height: 32px;
      transition: all 0.3s;
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 10;
      padding: 8px 12px;
      background: #fff;
      .required {
        color: red;
      }
    }
    .label-active {
      color: #cecbd4;
      font-size: 12px;
      height: 12px;
      line-height: 12px;
      font-weight: 400;
      z-index: 10;
      background: transparent;
      padding-top: 8px;
    }

    .inputControl {
      width: 100%;
      padding-top: 18px;
      padding-right: 20px;
      height: 46px;
      box-sizing: border-box;
      padding-left: 12px;
      @include placeHolder(#1d1d1f, 16px);
      position: absolute;
      z-index: 9;
      background: transparent;
      &.disabled-input {
        background: #e7e7e7;
        opacity: 0.5;
        z-index: 10;
        @include placeHolder(#000, 16px);
        cursor: not-allowed;
      }
    }
  }
  .common-input-box-active {
    border: 2px solid $fontColor;
    border-radius: 4px;
    margin-top: 0;
    margin-bottom: 0;
  }
  .common-input-box-red {
    border: 2px solid #BB0628;
    border-radius: 4px;
    margin-top: 0;
    margin-bottom: 0;
  }
  .input-icon {
    color: #C5CBD5;
    font-size: 22px;
    vertical-align: middle;
    position: absolute;
    z-index: 99;
    right: 8px;
    line-height: 44px;
    cursor: pointer;
  }
}
.custom-input-small {
  height: 56px;
  .common-input-box {
    height: 38px;
    .label-text {
      font-size: 14px;
      line-height: 20px;
      padding: 7px 10px;
    }
    .label-active {
      padding: 1px 10px;
      height: 14px;
      line-height: 12px;
      font-size: 12px;
    }
    .inputControl {
      height: 100%;
      padding: 14px 10px 2px;
      line-height: 14px;
      @include placeHolder(#1d1d1f, 14px);
      &.disabled-input {
        @include placeHolder(#000, 14px);
      }
    }
    .el-icon-error {
      line-height: 40px;
    }
  }
  .input-icon {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/inputBox.vue